<template>
  <div class="pageContent">
    <div class="lt-box wide">
      <p class="term-name">中国新县</p>
      <div class="zglt-img">
        <img src="@/assets/images/webIndex/img_text.png" />
      </div>
      <div class="describe"></div>
    </div>
    <div class="lt-box wide">
      <p class="term-name">魅力新县</p>
      <div class="mllt-box flex-container-bet">
        <div class="mllt-trem" v-for="(item, i) in mlxx" :key="i">
          <div class="mllt-img">
            <img :src="imgURl + 'xxszxc/' + item.slt" />
          </div>
          <div class="mllt-name">{{ item.bt }}</div>
          <div class="describe">
            <p>
              <span style="color: rgb(34, 34, 34)">
                {{ item.pubDesc }}
              </span>
            </p>
            <p><span style="color: rgb(34, 34, 34)"></span></p>
          </div>
          <div
            class="mllt-link"
            @click="gotoDetail('魅力新县', item.bt, item.id)"
          >
            <a href="javascript:;">了解更多</a>
          </div>
        </div>
      </div>
      <div class="lt-box wide">
        <p class="term-name">热门推荐</p>
        <a href="javascript:;">
          <div @click="goList('网站首页', '热门推荐')" class="more">
            更多&gt;&gt;
          </div>
        </a>
        <div
          class="rmtj-box flex-container-bet"
          v-if="recommeds && recommeds.length > 0"
        >
          <a
            href="javascript:;"
            @click="gotoDetail('热门推荐', item.bt, item.id)"
            v-for="(item, i) in recommeds.slice(0, 5)"
            :key="i"
          >
            <div class="rmtj-img">
              <img :src="imgURl + 'xxszxc/' + item.slt" />
              <div class="rmtj-name">{{ item.bt }}</div>
            </div>
          </a>
        </div>
        <div
          class="rmtj-box flex-container-bet"
          v-if="recommeds && recommeds.length > 0"
        >
          <a
            href="javascript:;"
            @click="gotoDetail('热门推荐', item.bt, item.id)"
            v-for="(item, i) in recommeds.slice(5, 11)"
            :key="i"
          >
            <div class="rmtj-img">
              <img :src="imgURl + 'xxszxc/' + item.slt" />
              <div class="rmtj-name">{{ item.bt }}</div>
            </div>
          </a>
        </div>
      </div>
      <div class="lt-box wide">
        <p class="term-name">出行锦囊</p>
        <div class="cxjn-box flex-container-ar">
          <div
            class="cxjn-trem"
            @click="gotoDetail('出行锦囊', item.bt, item.id)"
            v-for="(item, i) in cxjn"
            :key="i"
          >
            <a href="javascript:;">
              <div class="cxjn-img">
                <img :src="imgURl + 'xxszxc/' + item.slt" />
              </div>
              <div class="cxjn-link">{{ item.bt }}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const imgURl = API_IMG_URL;

export default {
  data() {
    return {
      imgURl: imgURl,
      // 魅力新县
      mlxx: [],
      // 热门推荐
      recommeds: [],
      // 出行锦囊
      cxjn: [],
    };
  },
  components: {},
  computed: {},
  methods: {
    gotoDetail(type, title, id) {
      this.$router.push({
        path: "detail",
        query: {
          type,
          title,
          id,
        },
      });
    },
    goList(meunname, type) {
      this.$router.push({
        path: "list",
        query: {
          meunname: meunname,
          type: type,
        },
      });
    },

    async getDataList() {
      try {
        let res1 = await this.$http.queryPageList({
          currentPage: 1,
          pubType: 11,
          pageSize: 4,
        });
        let res2 = await this.$http.queryPageList({
          currentPage: 1,
          pubType: 12,
          pageSize: 10,
        });
        let res3 = await this.$http.queryPageList({
          currentPage: 1,
          pubType: 13,
          pageSize: 4,
        });
        console.log(35, res1);
        this.mlxx = res1.response.records;
        this.recommeds = res2.response.records;
        this.cxjn = res3.response.records;
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    this.getDataList();
  },
};
</script>

<style lang="less" scoped>
.pageContent {
  .wide {
    width: 1200px;
    margin: 0 auto;
  }
  .lt-box {
    .term-name {
      padding: 40px 0 20px 0;
      font-size: 34px;
    }
    p {
      text-align: center;
    }
    .zglt-img {
      padding-bottom: 20px;
      img {
        width: 100%;
        height: 280px;
      }
    }
    .describe {
      color: #4b4b4b;
      text-indent: 2em;
      line-height: 30px;
    }
    .flex-container-bet {
      display: flex;
      justify-content: space-between;
    }
    .flex-container-ar {
      display: flex;
      justify-content: space-around;
    }
    .lt-box {
      position: relative;
      a {
        .more {
          position: absolute;
          right: 20px;
          top: 64px;
          cursor: pointer;
          color: #02d4d5;
          &:hover {
            color: #fea004;
          }
        }
      }
    }
    .mllt-box {
      .mllt-trem {
        position: relative;
        width: 290px;
        font-size: 16px;

        .mllt-img {
          img {
            width: 100%;
            height: 360px;
          }
        }
        .mllt-name {
          padding: 30px 0;
          font-size: 24px;
          text-align: center;
        }
        .describe {
          color: #4b4b4b;
          text-indent: 2em;
          line-height: 30px;
          font-size: 16px;
        }
        .mllt-link {
          padding-top: 20px;
          text-align: center;
          a {
            color: #02d4d5;
            &:hover {
              color: #fea004;
            }
          }
        }
      }
    }
    .rmtj-box {
      position: relative;
      margin-bottom: 10px;
      a {
        color: #000;
        text-decoration: none;
        .rmtj-img {
          position: relative;
          border: 1px solid #d4d4d4;
          padding: 4px;
          border-radius: 5px;
          overflow: hidden;
          img {
            width: 220px;
            height: 260px;
            cursor: pointer;
            vertical-align: top;
            transition: all 1s;
          }
          img:hover {
            transform: scale(1.4);
          }
          .rmtj-name {
            width: 220px;
            height: 30px;
            line-height: 30px;
            position: absolute;
            bottom: 4px;
            left: 50%;
            transform: translate(-50%);
            color: #fff;
            background: #000;
            text-align: center;
            cursor: pointer;
            opacity: 0.7;
            z-index: 1;
          }
        }
      }
    }
    .cxjn-trem {
      cursor: pointer;
      a {
        color: #000;
        text-decoration: none;
        .cxjn-link {
          padding-top: 20px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
